export const resolveTemplate = (
  template: string | undefined,
  valuesById: Record<string, unknown>,
) => {
  if (!template) return '';

  const stringifyTemplateValue = (value: unknown) => {
    if (typeof value === 'string') return value;
    if (typeof value === 'number' && Number.isFinite(value))
      return String(value);
    return '';
  };

  const isTruthyTemplateValue = (value: unknown) => {
    if (typeof value === 'string') return value.trim().length > 0;
    return Boolean(value);
  };

  const renderedIfElseBlocks = template.replaceAll(
    /{{#if\s+([^}]+)}}([\s\S]*?)(?:{{else}}([\s\S]*?))?{{\/if}}/g,
    (_match, rawKey: string, truthyBranch: string, falsyBranch = '') => {
      const key = String(rawKey).trim();
      return isTruthyTemplateValue(valuesById[key])
        ? truthyBranch
        : falsyBranch;
    },
  );

  const renderedHandlebarsTokens = renderedIfElseBlocks.replaceAll(
    /{{\s*([^}]+)\s*}}/g,
    (_match, rawKey: string) => {
      const key = String(rawKey).trim();
      if (key === 'else') return '';
      return stringifyTemplateValue(valuesById[key]);
    },
  );

  // Backward compatible fallback for existing single-brace templates.
  return renderedHandlebarsTokens.replaceAll(
    /\{([^}]+)\}/g,
    (_match, rawKey: string) => {
      const key = String(rawKey).trim();
      return stringifyTemplateValue(valuesById[key]);
    },
  );
};

export const decodeDefaultAddressValue = (value: string) => {
  const plusAsSpace = value.replaceAll('+', ' ');
  try {
    return decodeURIComponent(plusAsSpace);
  } catch {
    return plusAsSpace;
  }
};

export const parseDefaultAddressString = (
  value: string,
): Record<string, string> =>
  value.split('&').reduce<Record<string, string>>((acc, pair) => {
    if (!pair) return acc;
    const eqIndex = pair.indexOf('=');
    if (eqIndex <= 0) return acc;

    const key = pair.slice(0, eqIndex).trim();
    const rawValue = pair.slice(eqIndex + 1);
    if (!key) return acc;

    acc[key] = decodeDefaultAddressValue(rawValue);
    return acc;
  }, {});
